import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ConfirmProvider } from './components/shared/ConfirmDialog';
import { AvisoProvider } from './components/shared/Aviso';
import ProposalPublicView from './pages/ProposalPublicView';
import MaterialPublicView from './pages/MaterialPublicView';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Rota publica para visualizar proposta (/proposta e /p — /p é o link de
            compartilhamento com card rico: crawler cai no backend OG via rewrite
            Vercel condicional, humano cai aqui na SPA e a URL fica /p na barra) */}
        <Route path="/proposta/:code" element={<ProposalPublicView />} />
        <Route path="/p/:code" element={<ProposalPublicView />} />

        {/* Rota publica para visualizar material. Só por TOKEN: o `code` era sequencial
            (MAT000001...) e um único link entregava o catálogo público inteiro. */}
        <Route path="/m/t/:token" element={<MaterialPublicView />} />

        {/* Rota principal do sistema */}
        <Route path="/*" element={
          <AuthProvider>
            {/* Confirmação padrão do HUB. Fica acima do App pra qualquer tela
                poder chamar `useConfirm()` sem prop drilling. */}
            <ConfirmProvider>
              {/* O par do confirm para o que só informa: useAviso() no lugar de alert(). */}
              <AvisoProvider>
                <App />
              </AvisoProvider>
            </ConfirmProvider>
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
